import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { BsClock } from "react-icons/bs";
import logoCircle from "../assets/logo/logo_circle.png";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Modal auto-close setelah 3 detik
  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => setShowModal(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [showModal]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Full Name is required";
    if (!formData.phone) newErrors.phone = "Phone Number is required";
    if (!formData.message) newErrors.message = "Message is required";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length === 0) {
      setLoading(true);
      emailjs
        .send(
          "service_dcuwujh", // Service ID kamu
          "template_7ts8jup", // Template ID kamu
          formData,
          "PR_HZCXCIWDqp3v_s" // Public Key kamu
        )
        .then(
          (result) => {
            console.log("Email sent:", result.text);
            setSubmitted(true);
            setFormData({ name: "", phone: "", message: "" });
            setShowModal(true);
          },
          (error) => {
            console.error("Email failed:", error.text);
            alert("Failed to send message. Please try again later.");
          }
        )
        .finally(() => setLoading(false));
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <footer style={{ background: "#1d7d37", color: "white", borderTop: "3px solid #f59e0b" }}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "2rem", padding: "2rem" }}>
        {/* Kiri: Contact Info */}
        <div style={{ flex: 1, minWidth: "250px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.8rem", marginBottom: "1.5rem" }}>
            <img src={logoCircle} alt="Logo" style={{ height: "60px" }} />
            <span style={{ color: "#f59e0b", fontWeight: "bold", fontSize: "1rem" }}>
              PT. OTO KREASI INDONESIA
            </span>
          </div>

          <h3 style={{ marginBottom: "1rem", color: "#FFFFFF" }}>Contact Detail</h3>
          <div className="contact-item">
            <FaEnvelope /> <span>Mulyadi@otokresindo.com | admin@otokresindo.com | marketing@otokresindo.com</span>
          </div>
          <div className="contact-item">
            <FaPhoneAlt /> <span>(+62) 812-9610-043 - Bpk. Mulyadi - Direktur <br />
            (+62) 878-7797-7848 - Ibu. Imaa - Marketing</span>
          </div>
          <div className="contact-item">
            <FaMapMarkerAlt />{" "}
            <span>
              Kawasan Industri Jababeka Tahap 5, Jl. Science Boulevard No.mor 8 Blok A2, Sertajaya, Kec. Cikarang Tim., Kabupaten Bekasi, Jawa Barat 17530
            </span>
          </div>
          <div className="contact-item">
            <BsClock /> <span>Monday - Friday: 8:00 AM - 5:00 PM</span>
          </div>
        </div>

        {/* Kanan: Contact Form */}
        <div style={{ flex: 1, minWidth: "280px" }}>
          <h3 style={{ marginBottom: "1rem", color: "#FFFFFF" }}>Request Catalog</h3>
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <span className="error">{errors.name}</span>}

            <input
              type="text"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
            />
            {errors.phone && <span className="error">{errors.phone}</span>}

            <textarea
              name="message"
              rows="4"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
            />
            {errors.message && <span className="error">{errors.message}</span>}

            <button type="submit" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner" /> Sending...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </form>
        </div>
      </div>

      {/* Modal sukses */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>✅ Request Berhasil Dikirim!</h3>
            <p>Terima kasih, kami akan mereview request anda.</p>
            <button onClick={() => setShowModal(false)}>OK</button>
          </div>
        </div>
      )}

      <style>{`
        .contact-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 0.8rem;
          font-size: 0.95rem;
        }
        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
        }
        .contact-form input,
        .contact-form textarea,
        .contact-form button {
          width: 100%;
          padding: 0.7rem;
          border-radius: 6px;
          border: none;
          box-sizing: border-box;
          font-size: 0.95rem;
        }
        .contact-form button {
          background: #f59e0b;
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
        }
        .contact-form button:hover:not(:disabled) {
          background: #d97706;
        }
        .contact-form button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        .spinner {
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-top: 3px solid white;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .error {
          color: #f87171;
          font-size: 0.8rem;
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
        }
        .modal-content {
          background: white;
          color: #1d7d37;
          padding: 2rem;
          border-radius: 10px;
          text-align: center;
          max-width: 350px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
          animation: fadeIn 0.3s ease;
        }
        .modal-content h3 {
          margin-bottom: 0.5rem;
        }
        .modal-content button {
          background: #1d7d37;
          color: white;
          border: none;
          margin-top: 1rem;
          padding: 0.6rem 1.2rem;
          border-radius: 6px;
          cursor: pointer;
          transition: background 0.3s ease;
        }
        .modal-content button:hover {
          background: #155c29;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }

        @media (max-width: 768px) {
          footer > div:nth-child(1) {
            flex-direction: column;
            padding: 1.5rem;
          }
          footer > div:nth-child(1) > div {
            width: 100% !important;
            min-width: unset !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
